// extracted by mini-css-extract-plugin
export default {"PfsTabs":"PFSTabs_PfsTabs__BjhpA","tab":"PFSTabs_tab__70xRT","selected":"PFSTabs_selected__uPvO+"};